var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5833 16.5001H26.9667C26.3293 16.4987 25.7091 16.7062 25.2008 17.0907C24.6925 17.4752 24.3242 18.0156 24.1521 18.6292L20.725 30.8209C20.7029 30.8966 20.6569 30.9632 20.5938 31.0105C20.5306 31.0578 20.4539 31.0834 20.375 31.0834C20.2961 31.0834 20.2194 31.0578 20.1563 31.0105C20.0931 30.9632 20.0471 30.8966 20.025 30.8209L11.975 2.17925C11.9529 2.10352 11.9069 2.037 11.8438 1.98966C11.7806 1.94233 11.7039 1.91675 11.625 1.91675C11.5461 1.91675 11.4694 1.94233 11.4063 1.98966C11.3431 2.037 11.2971 2.10352 11.275 2.17925L7.84792 14.3709C7.67652 14.9822 7.31035 15.5208 6.80501 15.9051C6.29968 16.2894 5.68276 16.4983 5.04792 16.5001H1.41667",
    stroke: "#0071E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector6);
export default __webpack_public_path__ + "static/media/vector-6.d0e902f790fa23a58f50036566d1a0c5.svg";
export { ForwardRef as ReactComponent };